// Matches Tailwind's default `lg` breakpoint (1024px, unmodified in
// tailwind.config.js), which is the same breakpoint EquivalentSizesPage
// uses (`lg:grid-cols-[1fr_260px]`) to switch from a stacked single-column
// mobile layout to a two-column desktop layout with a sticky detail panel.
const DESKTOP_BREAKPOINT_QUERY = '(min-width: 1024px)';

/**
 * Smoothly scrolls the fit-detail panel into view after a result-card
 * selection — but only on the stacked (mobile/tablet) layout, where the
 * panel sits below the results list and tapping a card wouldn't otherwise
 * bring it on screen. On the desktop two-column layout the panel is already
 * visible alongside the results, so this intentionally no-ops there rather
 * than causing any scroll — the panel just updates in place.
 *
 * Respects prefers-reduced-motion by checking it directly at call time
 * (rather than relying only on the global CSS override), since an explicit
 * `behavior: 'smooth'` passed to scrollIntoView can take precedence over
 * CSS `scroll-behavior` in some browsers.
 */
export function scrollDetailIntoView(el: HTMLElement | null): void {
  if (!el) return;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
  if (window.matchMedia(DESKTOP_BREAKPOINT_QUERY).matches) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
}
